import axios from "axios";

export async function getBookings(status = 'all') {
  const base = process.env.REACT_APP_API_URL || '';
  if (status === 'all') {
    // Use the admin route to fetch all booking history records
    const res = await axios.get(`${base}/api/cars/all-bookings`);
    return res.data;
  } else {
    const url = `${base}/api/bookings?status=${encodeURIComponent(status)}`;
    const res = await axios.get(url);
    return res.data;
  }
}

export async function declineBooking(bookingRef) {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/bookings/${encodeURIComponent(bookingRef)}/decline`, {
    headers: { 'Content-Type': 'application/json' }
  });
  return res.data;
}
